import apiClient from '../axios';

export default {
    getArchivoPorLeccion(id) {
        return apiClient.get(`/archivos/leccion/${id}`);
    },

};